<template>
    <pre-notifications
        class="z-50 py-6 sm:py-4"
        :placement="placement"
        v-slot="{ notifications, onRemove, placementClassName }"
    >
        <transition-group
            class="w-full"
            enter-active-class="transform ease-out duration-300 transition"
            enter-class="-translate-y-2 opacity-0"
            enter-to-class="translate-y-0 opacity-100"
            leave-active-class="absolute transition ease-in duration-200"
            leave-class="opacity-100"
            leave-to-class="opacity-0"
            move-class="transition transform duration-200"
            tag="div"
        >
            <div
                class="w-full mb-1 px-8"
                :class="placementClassName"
                :key="notification.id"
                v-for="notification in notifications"
            >
                <nio-notification
                    :closable="notification.closable"
                    :description="notification.description"
                    :icon="notification.icon"
                    :link="notification.link"
                    :message="notification.message"
                    :type="notification.type"
                    @hide="onRemove(notification)"
                />
            </div>
        </transition-group>
    </pre-notifications>
</template>

<script>
    import { PreNotifications } from 'pre-ui';
    import NioNotification from '@/components/UI/NioNotification.vue';

    export default {
        components: {
            PreNotifications,
            NioNotification,
        },

        props: {
            placement: {
                type: String,
                required: true,
            },
        },
    };
</script>
